// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tab-content {\n  border: 0;\n}\n.tab-content .tab-pane {\n  padding: 0;\n}\n.card-header {\n  font-weight: 700;\n}\n@media only screen and (min-device-width: 600px) {\n#admin-menu-column {\n    max-width: 280px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
